import { createContext, type FC, type ReactElement, useState } from 'react';
import type { CellarCoolingModel, CellarCoolingSortingFields, Order } from '../models';

interface ICellarCoolingsContext {
  coolersUpdate: boolean;
  toggleUpdate: () => void;
  coolers: CellarCoolingModel[];
  setCellarCoolings: (val: CellarCoolingModel[]) => void;
  page: number;
  setPage: (val: number) => void;
  limit: number;
  setLimit: (val: number) => void;
  count: number;
  setCount: (val: number) => void;
  order: Order;
  setOrder: (val: Order) => void;
  orderBy: CellarCoolingSortingFields;
  setOrderBy: (val: CellarCoolingSortingFields) => void;
  loading: boolean;
  setLoading: (val: boolean) => void;
}

export const CellarCoolingsContext = createContext<ICellarCoolingsContext>({} as ICellarCoolingsContext);

export const CellarCoolingsProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const [coolersUpdate, setCellarCoolingsUpdate] = useState(false);
  const [coolers, setCellarCoolings] = useState<CellarCoolingModel[]>([]);
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [count, setCount] = useState<number>(0);
  const [order, setOrder] = useState<Order>('desc');
  const [orderBy, setOrderBy] = useState<CellarCoolingSortingFields>('name');
  const [loading, setLoading] = useState(false);
  const toggleUpdate = (): void => setCellarCoolingsUpdate(!coolersUpdate);

  return (
    <CellarCoolingsContext.Provider
      value={{
        coolersUpdate,
        toggleUpdate: toggleUpdate,
        coolers,
        setCellarCoolings,
        page,
        setPage,
        limit,
        setLimit,
        count,
        setCount,
        order,
        setOrder,
        orderBy,
        setOrderBy,
        loading,
        setLoading
      }}
    >
      {children}
    </CellarCoolingsContext.Provider>
  );
};
